import React, { useState, useEffect } from 'react';
import { Page, NotifyModal } from 'components';
import Header from '../../components/Header/Header';
import FileUpload from 'components/FileUpload';
import FileUploadTest from 'components/FileUploadTest';
import { Alert, Card, Button, Badge } from 'react-bootstrap';

const Charts = () => {
  const user = JSON.parse(localStorage.getItem('userData'))
  if (user?.permission?.charts?.read !== true || user?.permission?.charts?.write !== true) {
    window.location.replace('/home');
  }

  const [permission, setPermission] = useState(false);
  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);
  const [useTestMode, setUseTestMode] = useState(false);

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg })
    setModalShow(true)
  }

  useEffect(() => {
    setPermission(user?.permission?.units?.write)
  }, [])

  // Controle de tema
  const [currentTheme, setCurrentTheme] = React.useState(
    document.body.classList.contains('dark-theme') ? 'dark' : 'light'
  );

  React.useEffect(() => {
    const handleThemeChange = () => {
      setCurrentTheme(document.body.classList.contains('dark-theme') ? 'dark' : 'light');
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          handleThemeChange();
        }
      });
    });

    observer.observe(document.body, { attributes: true });
    return () => observer.disconnect();
  }, []);

  return (
    <Page className="p-3" title="Curvas">
      <Header page={"Curvas"} />

      <Card className={`mb-3 mt-3 p-3 ${currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}`}>
        
        <NotifyModal
          type={type}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Modo de Upload</h5>
          <div className="d-flex align-items-center gap-2">
            <Badge bg={useTestMode ? "warning" : "success"}>
              {useTestMode ? "⚠️ Modo Teste (Sem Validações)" : "🔒 Modo Produção (Com Validações)"}
            </Badge>
            <Button
              size="sm"
              variant={useTestMode ? "outline-success" : "outline-warning"}
              onClick={() => setUseTestMode(!useTestMode)}
            >
              {useTestMode ? "Ativar Validações" : "Desativar Validações"}
            </Button>
          </div>
        </div>

        <Alert variant="warning" className='p-2'>
          <Alert.Heading>Atenção!</Alert.Heading>
          <p>
            Ao enviar a nova curva, a curva atual será substituída definitivamente! Certifique-se de que os dados estão corretos antes de prosseguir.
          </p>
          <hr />
          <p className="mb-0">
            Todos os equipamentos com conexão à internet serão atualizados automaticamente.
          </p>
        </Alert>

        <hr />

        {/* Type = CUSTOM, INMETRO, COMPLEMENT */}
        <h4>Curva Inmetro</h4>
        {useTestMode ? (
          <FileUploadTest
            msg={"Enviar a nova curva substituirá a curva INMETRO atual!"}
            type={"INMETRO"}
            permission={permission}
            handleAlertModalError={handleAlertModalError}
            handleAlertModalSuccess={handleAlertModalSuccess}
          />
        ) : (
          <FileUpload
            msg={"Enviar a nova curva substituirá a curva INMETRO atual!"}
            type={"INMETRO"}
            permission={permission}
            handleAlertModalError={handleAlertModalError}
            handleAlertModalSuccess={handleAlertModalSuccess}
          />
        )}

        <hr />

        <h4>Curva Complementar</h4>
        {useTestMode ? (
          <FileUploadTest
            msg={"Enviar a nova curva substituirá a curva COMPLEMENTAR atual!"}
            type={"COMPLEMENT"}
            permission={permission}
            handleAlertModalError={handleAlertModalError}
            handleAlertModalSuccess={handleAlertModalSuccess}
          />
        ) : (
          <FileUpload
            msg={"Enviar a nova curva substituirá a curva COMPLEMENTAR atual!"}
            type={"COMPLEMENT"}
            permission={permission}
            handleAlertModalError={handleAlertModalError}
            handleAlertModalSuccess={handleAlertModalSuccess}
          />
        )}

      </Card>
    </Page>
  );
};

export default Charts;
